export const getCategoriesList = () => ({ url: 'categories_tree' })
